import { Component } from "react";
import TopNav from "../components/top_nav";
import { ArrowRight } from 'react-bootstrap-icons';
import Footer from "../components/footer";

const features = [
    "Smart Signaling Systems",
    "Real-Time Rail Analytics",
    "Predictive Maintenance Using AI",
    "Safety-Critical Hardware",
    "Interoperable Protocols",
    "Green & Energy-Efficient Tech",
    "Simulation-Driven Testing",
];



const contentRow = [
    {
        title: "Deep R&D Roots",
        description:
            "Our dedicated R&D teams are at the forefront of innovation, exploring next-gen technologies in automation, AI-driven control systems, sensor networks, and sustainable rail infrastructure. Every solution we develop is future-ready, scalable, and designed to transform how rail networks operate.",
        img: "/approach3.webp",
    },
    {
        title: "Built for the Field",
        description:
            "From ideation to real-world application, we engineer solutions that are not just smart—but robust, adaptable, and proven in the toughest rail environments. Our technologies are built to perform reliably in diverse conditions, ensuring on-ground success beyond the lab.",
        img: "/approach1.webp",
    },
    {
        title: "System-Level Thinking",
        description:
            "Rail networks function as complex ecosystems. Our approach integrates safety, performance, and interoperability at every level—ensuring seamless communication between subsystems and enhancing overall network intelligence for long-term reliability.",
        img: "/approach4.webp",
    },
    {
        title: "Purpose-Driven Design",
        description:
            "Every innovation we deliver is driven by a singular purpose: to build safer, smarter, and more efficient railways. Through thoughtful design and future-focused engineering, we empower rail operators to meet global safety standards while embracing next-generation capabilities.",
        img: "/approach2.webp",
    },
];



export default class InnovationScreen extends Component {
    render() {
        return (
            <div>
                <TopNav />

                <div className="position-relative px-3 d-flex align-items-center hero-section">
                    <img
                        src="/innovation.webp"
                        alt="innovation"
                        className="img-fluid w-100 h-100 position-absolute top-0 start-0"
                        style={{ objectFit: "cover", zIndex: 1 }}
                    />

                    <div
                        className="position-absolute top-50 start-50 translate-middle text-white w-100 px-3 px-md-5 hero-content"
                        style={{ zIndex: 3 }}
                    >
                        <span className="badge rounded-pill bg-white border-primary-blue text-grey-color px-3 py-2 mb-2 mx-md-4">
                            <span className="me-2 text-success">●</span>Engineering What’s Next in Rail.
                        </span>

                        <div className="col-12 col-md-10 mx-md-4">
                            <p className="hero-title">Innovation isn’t a department <br />— it’s our DNA.</p>
                        </div>
                        <div className="col-12 col-md-7 mx-md-4 mb-5">
                            <p className="hero-description">
                                For over four decades, we’ve been pushing the boundaries of what’s possible in rail
                                technology. We don’t just respond to industry change — we drive it. Whether it's
                                modernizing legacy systems or building next-gen rail infrastructure from the ground
                                up, our focus is always on meaningful innovation that solves real-world challenges.
                            </p>
                        </div>
                    </div>
                </div>


                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center text-center">
                            <h2 className="fs-36">Our Approach to Innovation</h2>
                        </div>
                    </div>
                </div>

                <div className="row mx-0 justify-content-center mt-5 pt-3">
                    <div className="col-12 col-md-10 px-0">
                        <div className="row mx-0">
                            {contentRow.map((item, index) => (
                                <div
                                    key={index}
                                    className="col-12 col-sm-6 col-lg-3 d-flex flex-column justify-content-between mb-4 mb-lg-0"
                                >
                                    {/* If even index, text above image */}
                                    {index % 2 === 0 ? (
                                        <>
                                            <div className="mt-2 px-3">
                                                <p className="fw-bold text-primary-blue fs-16">{item.title}</p>
                                                <p className="fs-12">{item.description}</p>
                                            </div>
                                            <div className="responsive-img-container">
                                                <img
                                                    src={item.img}
                                                    alt={item.title}
                                                    className="img-fluid rounded-3 w-100 h-100"
                                                    style={{ objectFit: "cover" }}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {/* On small screens, reverse order with flex-column-reverse */}
                                            <div className="d-flex flex-column flex-sm-column-reverse">
                                                <div className="px-3 mt-4">
                                                    <p className="fw-bold text-primary-blue fs-16">{item.title}</p>
                                                    <p className="fs-12">{item.description}</p>
                                                </div>
                                                <div className="responsive-img-container">
                                                    <img
                                                        src={item.img}
                                                        alt={item.title}
                                                        className="img-fluid rounded-3 w-100 h-100"
                                                        style={{ objectFit: "cover" }}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="container my-5">
                    <div className="bg-grey-color p-4 p-md-5 rounded-4">
                        <div className="row align-items-center">
                            {/* Text Section */}
                            <div className="col-12 col-md-6">
                                <span className="badge fw-normal rounded-pill border-primary-blue text-grey-color px-3 py-2 mb-3">
                                    <span className="me-2 text-success">●</span>From Lab to Locomotive
                                </span>
                                <p className="fs-36 fw-bold mb-3">Areas We’re Innovating In</p>
                                <p>
                                    Our technologies don’t sit in research papers
                                    <br />— they <span className="fw-bold">power real railways.</span>
                                </p>
                                <p className="w-75">
                                    From metro networks to freight corridors, BHEPL innovations
                                    are already helping shape the backbone of modern transport systems.
                                </p>
                                <div className="py-1">
                                    <div className="d-flex flex-column gap-1">
                                        {features.map((text, index) => (
                                            <div
                                                key={index}
                                                className="d-flex align-items-center px-4 py-2 bg-white rounded-pill border-grey-color w-100 w-md-75"
                                            >
                                                <div className="me-3 text-primary-blue">
                                                    <i className="bi bi-check-circle-fill fs-13"></i>
                                                </div>
                                                <span className="fw-medium fs-14">{text}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <button
                                    onClick={() => window.location.href = "solutions"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue mt-2"
                                >
                                    <span className="mx-3">Explore Our Solutions</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>

                            {/* Image Section */}
                            <div className="col-12 col-md-6 text-center mt-4 mt-md-0">
                                <img
                                    src="/drawing.webp"
                                    alt="Drawing"
                                    className="img-fluid rounded-4 shadow-sm w-100"
                                    style={{ maxHeight: "650px", objectFit: 'cover' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>




                <div className="row justify-content-center mx-0">
                    <div className="col-12 col-md-10 my-5">
                        <div className="row align-items-center bg-white rounded-4 p-3 p-md-4">
                            <h3 className="mb-4 fw-semibold fs-24 px-md-0">Explore Case Studies</h3>

                            <div className="col-12 col-md-6 mb-4 mb-md-0 px-md-0" style={{ height: "418px" }}>
                                <img
                                    src="/solutions01.avif"
                                    alt="case study"
                                    className="img-fluid rounded-4 w-100 h-100"
                                    style={{
                                        objectFit: 'cover',
                                        height: '100%',
                                        width: '100%',
                                        minHeight: '418px',
                                        maxHeight: '418px',
                                    }}
                                />
                            </div>

                            <div
                                className="col-12 col-md-6 d-flex flex-column justify-content-between ps-md-4"
                                style={{
                                    minHeight: '200px',
                                }}
                            >
                                <div>
                                    <h4 className="fw-bold mb-3 fs-36">
                                        Yard Safety Management Solution Deployment at Large Steel Producer
                                    </h4>
                                </div>
                                <div>
                                    <p className="text-primary-blue mb-3">
                                        Implemented a Robust Yard Safety Management Solution at the Angul plant of a leading
                                        steel producer. The system enhances safety through real-time monitoring, automated
                                        access control, and incident tracking.
                                    </p>
                                    <p className="text-primary-blue fs-16">
                                        — Improving compliance, visibility, and operational efficiency in a high-risk industrial
                                        environment.
                                    </p>
                                </div>
                                <div>
                                    <button
                                        onClick={() => window.location.href = "case-studies/case-study"}
                                        className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                    >
                                        <span className="mx-3 fs-14">View Case Study</span>
                                        <div
                                            className="d-flex justify-content-center align-items-center rounded-circle"
                                            style={{
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: '#ffffff',
                                            }}
                                        >
                                            <ArrowRight color="#193E6C" />
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container my-5">
                    <div className="bg-grey-color p-4 p-md-5 rounded-4">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <h6 className="fs-20 text-primary-blue fw-bold">Meet Our Team</h6>
                                <p className="fs-32 fw-bold mb-1">Let’s Build the Railways of Tomorrow</p>
                                <p className="fs-18">
                                    Whether you’re modernizing legacy infrastructure or pioneering new corridors,
                                    BHEPL is your trusted technology ally. Together, let’s shape the intelligent
                                </p>
                                <button
                                    onClick={() => window.location.href = "contact"}
                                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                                >
                                    <span className="mx-3 fs-14">Contact us for Strategic Collaboration</span>
                                    <div
                                        className="d-flex justify-content-center align-items-center rounded-circle"
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                            backgroundColor: '#ffffff',
                                        }}
                                    >
                                        <ArrowRight color="#193E6C" />
                                    </div>
                                </button>
                            </div>

                            <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                                <img
                                    src="/discuss2.webp"
                                    alt="Discuss"
                                    className="img-fluid rounded-4 shadow-sm w-100"
                                    style={{
                                        objectFit: 'cover',
                                        width: '100%',
                                        height: 'auto',
                                        minHeight: '200px',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <Footer />




            </div>
        );
    }
}